var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedBackDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    rx: 27.5,
    fill: "#FDDEDE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 36.5C21.95 36.5 21.4793 36.3043 21.088 35.913C20.6967 35.5217 20.5007 35.0507 20.5 34.5V21.5H19.5V19.5H24.5V18.5H30.5V19.5H35.5V21.5H34.5V34.5C34.5 35.05 34.3043 35.521 33.913 35.913C33.5217 36.305 33.0507 36.5007 32.5 36.5H22.5ZM32.5 21.5H22.5V34.5H32.5V21.5ZM24.5 32.5H26.5V23.5H24.5V32.5ZM28.5 32.5H30.5V23.5H28.5V32.5Z",
    fill: "#F20000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedBackDelete);
export default __webpack_public_path__ + "static/media/Red_Back_Delete.4643518f88abfb953b5747b9e8ec784c.svg";
export { ForwardRef as ReactComponent };